import { ButtonSecondary } from '@klarna/bubble-ui';
import { hooks as i18nHooks } from 'mage-i18n';
import insights from 'mage-insights';
import React, { useEffect } from 'react';
import { useClientIdController } from '../../controllers/ClientIdController';
import { useMidController } from '../../controllers/MidController';
import { usePluginController } from '../../controllers/PluginController';
const TRANSLATION_PREFIX = 'home-fe.boosters-plugin.instructions.client-id';
const redirectToSettingsPage = () => {
    window.location.href = '/settings/credentials/client-keys';
};
export const ManageClientIdButton = () => {
    const t = i18nHooks.useTranslator();
    const { selectedMid } = useMidController();
    const { pluginId } = usePluginController();
    const { areActionsEnabled } = useClientIdController();
    useEffect(() => {
        insights.event({
            category: `boost-home/plugin-guide/${pluginId}/manage-client-id`,
            action: 'impression',
            label: selectedMid !== null && selectedMid !== void 0 ? selectedMid : undefined
        });
    });
    const clickHandler = () => {
        insights.event({
            category: `boost-home/plugin-guide/${pluginId}/manage-client-id`,
            action: 'click',
            label: selectedMid !== null && selectedMid !== void 0 ? selectedMid : undefined
        });
        redirectToSettingsPage();
    };
    return (React.createElement(ButtonSecondary, { size: 'medium', disabled: !areActionsEnabled, onClick: clickHandler }, t(`${TRANSLATION_PREFIX}.manage`)));
};
